<template>
	<div>
		<vs-table stripe noDataText="سفارشی موجود نیست." :data="ordersList" >
			<template slot="header">
				<vs-button @click="addOrder()" class="mb-4">سفارش سرویس</vs-button>
			</template>

			<template slot="thead">
				<vs-th>	شماره سفارش </vs-th>
				<vs-th>	کاربر </vs-th>
				<vs-th> مسئول </vs-th>
				<vs-th> وضعیت </vs-th>
				<vs-th>  </vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{data[indextr].order_number}}
					</vs-td>

					<vs-td>
						{{data[indextr].user.name}} {{data[indextr].user.last_name}}
					</vs-td>

					<vs-td>
						{{data[indextr].admin.name}} {{data[indextr].admin.last_name}}
					</vs-td>

					<vs-td>
						<span :style="itemRowBackground(data[indextr].status)" class="statusStyle">
							{{data[indextr].status}}
						</span>
					</vs-td>
					
					<vs-td class="">
						<feather-icon icon="MessageSquareIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current button-link" class="mr-4" @click="gotoChat(data[indextr].user.id, data[indextr].id)"/>
						<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" @click="editOrder(data[indextr].id)"/>
						<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="button-link" @click="deleteOrder(data[indextr].id)"/>
						
            		</vs-td>
				</vs-tr>
                <div class="float-left">
					<vs-pagination class="mt-4" :total="last_page" v-model="table_options.current_page"></vs-pagination>
				</div>
			</template>
		</vs-table>

		<AddOrderService :popupAddOrder='popupAddOrder' @updatePopupAddOrder='updatePopupAddOrder'/>

		<EditOrderService :popupEditOrder='popupEditOrder' :orderId='editOrderId' @updatePopupEditOrder='updatePopupEditOrder'/>

		<DeleteOrderService :popupDeleteOrder='popupDeleteOrder' :orderId='deleteOrderId' @updatePopupDeleteOrder='updatePopupDeleteOrder'/>
	
	</div>
</template>

<script>
import AddOrderService from './Add'
import EditOrderService from './Edit'
import DeleteOrderService from './Delete'

export default {
	components: {
		AddOrderService,
		EditOrderService,
		DeleteOrderService,
	},

	data() {
		return{
			popupAddOrder: false,
			popupEditOrder: false,
			popupDeleteOrder: false,

			editOrderId: 0,
			deleteOrderId: 0,
			
            last_page: 0,
			table_options: {
				current_page: 1,
			},
		}
	},

	computed: {
		ordersList() {
      		return this.$store.state.orders.orders
		},
	},

	watch: {
		"table_options.current_page": function () {
			this.getOrders();
		},
	},

	created(){
		this.getOrders();
	},

	methods: {
		itemRowBackground(status) {
			if (status === "سفارش جدید") return "background-color: #FDD835;";
			else if (status === "در حال بررسی") return "background-color: #F9A825;";
			else if (status === "در انتظار تایید مشتری") return "background-color: #F57F17;";
			else if (status === "تایید مشتری") return "background-color: #81C784;";
			else if (status === "مرحله اندازه گیری") return "background-color: #66BB6A;";
			else if (status === "مرحله تولید") return "background-color: #43A047;";
			else if (status === "مرحله ارسال") return "background-color: #388E3C;";
			else if (status === "مرحله نصب") return "background-color: #2E7D32;";
			else if (status === "تکمیل شده") return "background-color: #1B5E20;";
			else if (status === "کنسل شده") return "background-color: #9E9E9E;";
		},

        getOrders(){
			this.$vs.loading()
			let data = {
				type: 'service',
				page: this.table_options.current_page
			}
			this.$store.dispatch('getOrders', data )
			.then((res) => {
				this.last_page = res.data.data.last_page;
				this.$vs.loading.close()
			}).catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'خطا در اتصال به اینترنت',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		},

		addOrder(){
			this.popupAddOrder = true
		},

		editOrder(id){
			this.popupEditOrder = true
			this.editOrderId = id
		},
		
		deleteOrder(id){
			this.popupDeleteOrder = true
			this.deleteOrderId = id
		},

        updatePopupAddOrder(value){
            this.popupAddOrder = value
		},

		updatePopupEditOrder(value){
            this.popupEditOrder = value
		},
		
		updatePopupDeleteOrder(value){
            this.popupDeleteOrder = value
        },

		gotoChat(userId, orderId) {
			localStorage.setItem('orderId', orderId)
			localStorage.setItem('userId', userId)
			localStorage.setItem('type', 'product')
            this.$router.push({name: 'page-chat'}).catch(() => {})
        }
  	}
}
</script>

<style>
.center {
    padding: 2.2rem !important;
}
.button-link {
	cursor: pointer;
}
.vs-con-table .vs-con-tbody {
    border: unset !important;
}
</style>